<template>
<div class="home">
    <div class="header">
    <HeaderBar></HeaderBar>
    <HeaderMenu :cartQty=cartQty :productSalesPrice=productSalesPrice @childEvent="popupCheckout"></HeaderMenu>
    <AppLoading v-if="loading" />
    </div>

    <!-- Marquee Announcement -->
    <div class="marquee-wrapper">
      <marquee behavior="scroll" direction="left" class="marquee-text" v-html="getBannerDetails.scroll_content">
      </marquee>
    </div>

    <div class="content">
             <!-- <v-card class="mt-1 mx-auto bg-background pa-3" elevation="0" >
          <div class="d-flex flex-column fill-height justify-center align-center text-black ">
            <h1 class="primary--text">
              {{ getBannerDetails.title }}
            </h1>
          </div>
        </v-card> -->
      <v-container fluid>
        <div v-html="getBannerDetails.details" class="text-justify"></div>
      </v-container>
     
    </div>

    <div class="footer">
    <FooterSection ></FooterSection>
    </div>
  </div>

  
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions,mapGetters } from "vuex";
// Components
// import HelloWorld from '../components/HelloWorld.vue';

import HeaderBar from '../components/HeaderBar.vue';
import HeaderMenu from '../components/HeaderMenu.vue';
import AppLoading from "../components/Loading.vue";
import FooterSection from '../components/Footer.vue';
export default defineComponent({
  name: 'HomeView',
  data: () => ({
    productSalesPrice: "0.00",
    cartQty:0,
  }),
  components: {
    HeaderBar,
    HeaderMenu,
    AppLoading,
    FooterSection,
  },
  computed: {
    ...mapGetters([
      "authStatus",
      "authStatusError",
      "authStatusresponse",
      "getBannerDetails",
    ]),
    loading: function () {
      return this.authStatus === "loading";
    },
  },
  created() {
    this.fetchPageDetails("9");
  },
  methods: {
    ...mapActions([
      "fetchPageDetails",
    ]),
  }
});

</script>

<style scoped>
.marquee-wrapper {
  margin: 0px 0;
  border-radius: 0px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.marquee-text {
  color: #fff;
  background: linear-gradient(90deg, #d32f2f 60%, #b71c1c 100%);
  font-size: 1.2rem;
  font-weight: bold;
  padding: 10px 0;
  letter-spacing: 1px;
  text-shadow: 1px 1px 2px #00000022;
}
</style>